module.exports = __webpack_public_path__ + "static/rebecca-cover-4b2fad795c9a19f8b903df7ed0a0f1ff.png";